import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana18Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
    <rect width="1221" height="921" fill="url(#pattern0_1467_37583)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M382.861 589.621L480.043 545.448L424.09 424.707L382.861 442.376C376.972 485.568 365.192 572.541 365.192 574.897C367.548 586.677 377.953 589.621 382.861 589.621Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M559.568 510.112L480.056 545.451L424.103 424.71L447.662 412.93H515.395L559.568 510.112Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M692.08 421.765L515.385 412.93L559.559 510.112L700.914 448.269C707.982 429.422 697.97 422.747 692.08 421.765Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_37583" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_37583" transform="matrix(0.00403943 0 0 0.00535521 -8.57903 -2.16841)"/>
    </pattern>
    <image id="image0_1467_37583" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};